const routes = [
  // {
  //   path: '/',
  //   name: 'index',
  //   meta: {
  //     checkLogin: true,
  //     title: '工作台',
  //   },
  //   component: () => import('@/views/main/index.vue'),
  // },
  {
    path: '/',
    // name: 'LayoutIndex',
    checkLogin: false,
    component: () => import('@/views/main/Layout.vue'),
    children: [
      {
        path: '/',
        name: 'mainIndex',
        meta: {
          checkLogin: false,
          title: '工作台',
        },
        component: () => import('@/views/main/index.vue'),
      },
    ],
  },
  // {
  //   path: '/',
  //   // meta: {
  //   //   checkLogin: false,
  //   //   title: '工作台',
  //   // },
  //   redirect: '/standardProduct/productVersion/index',
  // },
  // {
  //   path: '/index',
  //   redirect: '/operateCenter/merchantManage/myMerchant/index',
  // },
  {
    path: '/login',
    name: 'login',
    meta: {
      checkLogin: false,
      title: '登陆',
    },
    component: () => import('@/views/main/Login.vue'),
  },
  {
    path: '/register',
    name: 'register',
    meta: {
      checkLogin: false,
      title: '注册',
    },
    component: () => import('@/views/main/Register.vue'),
  },
  {
    path: '/forgetPass',
    name: 'forgetPass',
    meta: {
      checkLogin: false,
      title: '忘记密码',
    },
    component: () => import('@/views/main/ForgetPass'),
  },
];
export default routes;
